import normal from './normal'
import baseMagic from './baseMagic'

export default {
  ...normal,
  ...baseMagic
}
